import { Bell } from 'lucide-react';
import { Monogram } from './Monogram';
import { AvatarMenu } from './AvatarMenu';

interface TopBarProps {
  center?: React.ReactNode;
  notifCount?: number;
}

/** Topbar для экранов без выбранного проекта (Projects, Admin landing).
    Когда проект выбран — используется DashboardTopBar с селекторами.
    Меню пользователя — общий AvatarMenu (как везде), без плашки тарифа
    (проект не выбран). */
export function TopBar({ center, notifCount = 0 }: TopBarProps) {
  return (
    <header
      className="sticky top-0 z-40 bg-white border-b border-border"
      style={{ height: 56 }}
    >
      <div className="mx-auto h-full flex items-center" style={{ maxWidth: 1280, paddingLeft: 24, paddingRight: 24, gap: 16 }}>
        <div className="flex items-center" style={{ gap: 10 }}>
          <Monogram size={32} fontSize={18} />
          <span className="font-heading text-ink" style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-0.01em' }}>
            Коллегиум
          </span>
        </div>

        <div className="flex-1 flex justify-center">{center}</div>

        <div className="flex items-center" style={{ gap: 12 }}>
          <button type="button" className="relative text-muted hover:text-ink" aria-label="Уведомления">
            <Bell size={20} />
            {notifCount > 0 && (
              <span
                className="absolute flex items-center justify-center rounded-pill tabular"
                style={{
                  top: -6, right: -6,
                  minWidth: 16, height: 16, padding: '0 4px',
                  background: '#F59E0B', color: '#0A1628',
                  fontFamily: 'Inter', fontWeight: 600, fontSize: 10, lineHeight: 1,
                }}
              >{notifCount}</span>
            )}
          </button>
          <AvatarMenu />
        </div>
      </div>
    </header>
  );
}
